module.exports = "/_next/static/images/59ccdc3bf48dac7269684e2d5e114430-cards@3x.png";